module.exports = __webpack_public_path__ + "static/warehouse-exp-img-2-element-75107851dca41cc17e1a78202f2208e7.png";